export const isPODomain = () => window.location.href.includes(process.env.REACT_APP_PO_DOMAIN);
